export const COUNTRY_NOT_ALLOWED = 'country-not-allowed';